import produce from 'immer';
import { Reducer } from 'redux';

import { DocumentsState, DocumentsTypes } from '../types';

const initialState: DocumentsState = {
    isLoading: false,
    documents: [],
};

const documentsReducer: Reducer<DocumentsState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case DocumentsTypes.GET_DOCUMENTS_LIST: {
                draft.isLoading = false;
                draft.documents = action.payload.documents;
                break;
            }
            case DocumentsTypes.REQUEST_GET_DOCUMENTS_LIST: {
                draft.isLoading = true;
                break;
            }
            case DocumentsTypes.SAVE_DOCUMENT: {
                draft.isLoading = false;
                draft.documents = draft.documents.map((item) => {
                    return item.type !== action.payload.document.type ? item : action.payload.document;
                });
                break;
            }
            case DocumentsTypes.REQUEST_SAVE_DOCUMENT: {
                draft.isLoading = true;
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

export { documentsReducer };
